import {
	Account,
	AssetMatchesBrandStatus,
	AssetStatus,
	Brand,
	ContractType,
	OrderType,
	PriorityLevel,
	PropostaTimeline,
	SearchFilter,
} from "models"
import { RawDraftContentState } from "draft-js"
import { DateTime } from "luxon"

export class MatchProposalFilter extends SearchFilter {
	brand: string | null = null
	priority: PriorityLevel | null = null
	status: AssetMatchesBrandStatus | null = null
	compatibility: number | null = null
	operator: string | null = null
	address: string | null = null

	pageSize: number = 10
	pageId: number = 0
	orderType: OrderType | null = null
	orderBy: string | null = null
}

export interface NewMatchRequest {
	assetId: string
	brandId: string
	compatibility: number
}

export interface SendNewProposalRequest {
	assetId: string
	brandIds: string[]
	subject: string
	type: ContractType
	expirationDate: Date
	price: number
	message: RawDraftContentState
}

export interface UpdateProposalRequest {
	type: ContractType
	expirationDate: Date
	creationDate: Date
	price: number
	message: RawDraftContentState
	paymentTerms: string,
	priority: PriorityLevel,
	compatibility: number,
	status: AssetMatchesBrandStatus
}

export interface Proposal {
	assetId: string
	brandIds: string[]
	subject: string
	paymentTerms: string
	type: ContractType
	expirationDate: string
	creationDate: string
	price: number
	accountManager: Account
	message: RawDraftContentState
	propostaTimeline: PropostaTimeline
}

export interface BrandOption {
	name: string,
	id: string
}

const PrecompiledTemplateText: string = "Hai ricevuto una nuova proposta da parte di MASEMA per il tuo brand {{brand}}! \n" + "Abbiamo trovato un interessante immobile in {{asset-zone}}, accedi alla piattaforma per visualizzare i dettagli e proseguire nella valutazione della proposta"

export const PrecompiledTemplate: RawDraftContentState = {
	blocks: [
		{
			key: "initial",
			text: PrecompiledTemplateText,
			type: "unstyled",
			depth: 0,
			inlineStyleRanges: [],
			entityRanges: [],
			data: {},
		}
	],
	entityMap: {}
}

export interface MatchTimeline {
	id: string
	timelineId: string
	name: string
	type: MatchActionType
	creationDate: string // ISO 8601 string
	executionDate: string // ISO 8601 string
	order: number
	creator: Account | null
	executor: Account | null
	status: AssetMatchesBrandStatus
	content: string | null

	reason?: string
	oldStatus?: AssetMatchesBrandStatus
	newStatus?: AssetMatchesBrandStatus
	visitDate?: string
}

export enum MatchActionType {
	SENT = "SENT",
	CALL = "CALL",
	VISIT = "VISIT",
	CHANGE_STATUS = "CHANGE_STATUS",
	EMAIL = "EMAIL",
	PHONE_CALL = "PHONE_CALL",
	LETTER = "LETTER",
	SURVEY = "SURVEY",
	CREATION = "CREATION",
	VISIBILITY_CHANGED = "VISIBILITY_CHANGED",
	ACCEPTED = "ACCEPTED"
}
